export default {
  abi:  [
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "name",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "symbol",
          "type": "string"
        },
        {
          "internalType": "uint256",
          "name": "_totalPer",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_amountPerAddress",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "allowance",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "needed",
          "type": "uint256"
        }
      ],
      "name": "ERC20InsufficientAllowance",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "sender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "balance",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "needed",
          "type": "uint256"
        }
      ],
      "name": "ERC20InsufficientBalance",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "approver",
          "type": "address"
        }
      ],
      "name": "ERC20InvalidApprover",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "receiver",
          "type": "address"
        }
      ],
      "name": "ERC20InvalidReceiver",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "ERC20InvalidSender",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "ERC20InvalidSpender",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "OwnableInvalidOwner",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "OwnableUnauthorizedAccount",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "claimant",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "TokensClaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "amountPerAddress",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "claimTokens",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "creationBlock",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "creator",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractDetails",
      "outputs": [
        {
          "internalType": "string",
          "name": "_name",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "_symbol",
          "type": "string"
        },
        {
          "internalType": "uint256",
          "name": "_totalSupplyCap",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_amountPerAddress",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_remainingAddresses",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_totalPer",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_creationBlock",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "_creator",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_owner",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "hasClaimed",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "remainingAddresses",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalPer",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupplyCap",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  bytecode:"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"
}



// WEBPACK FOOTER //
// ./src/erc20/Fairlaunch.js